import { FunctionComponent } from "react";
import Layout from "../Layout/Layout";

export default function WithLayout<
  T extends Record<string, unknown>
  // & IAppContext
>(Component: FunctionComponent<T>) {
  return function withLayoutComponent(props: T): JSX.Element {
    return (
      //   <AppContextProvider menu={props.menu} firstCategory={props.firstCategory}>
      <Layout>
        <Component {...props} />
      </Layout>
      //   </AppContextProvider>
    );
  };
}
